/** @jsx jsx */
import React, { useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { css, jsx } from '@emotion/core';
import { utilityColor } from 'components/styles';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FlexBox from 'components/atoms/FlexBox';
import useComponentVisible from 'hooks/useComponentVisible';
import Icon from 'components/atoms/Icon';
import { SubActionButton } from 'components/atoms/Button';
import ContextMenuBox from './ContextMenuBox';
import { ContextMenuType } from './type';
import ButtonText from 'components/atoms/Button/ButtonText';

const style = {
  contextMenu: css`
    border-radius: 3px;
    > div {
      background-color: white;
    }
  `,
};

const ContextMenu: React.FC<{
  text: string;
  buttons: ContextMenuType[],
  action?: number;
  disabled?: boolean,
  position?: 'bottom' | 'right',
  customStyle?:any,
  isButtonText?:boolean,
  hiddenDropIcon?: boolean
}> = ({
  text,
  buttons,
  action = 0,
  disabled,
  position,
  customStyle,
  isButtonText,
  hiddenDropIcon = false
}) => {
    const {
      ref,
      isComponentVisible,
      setIsComponentVisible,
    } = useComponentVisible(false);

    const bodyNode = document.querySelector('body') as HTMLBodyElement;
    const [parentEle, setParentEle] = useState<HTMLElement | null>(null);

    useEffect(() => {
      setParentEle(ref.current);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickMenu = useCallback(() => {
      // if (belongOrgFix && belongOrgFix === '1') {
      //   return;
      // }

      setIsComponentVisible(!isComponentVisible);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]); 
    
    return (
      <FlexBox
        customStyle={css({
          justifyContent: 'center',
        })}
      >
        <FlexBoxItem>
          <div ref={ref}>
            {
              isButtonText 
              ? <ButtonText customStyle={customStyle} onClick={disabled ? () => {} : handleClickMenu} text={text} action={action}>
                <Icon type="download" margin={"10px"} color={'#007BC3'} />
                {text}
                {!hiddenDropIcon && (
                  <Icon type="dropdown" color={'#007BC3'} />
                )}
              </ButtonText>
              : <SubActionButton customStyle={customStyle} onClick={disabled ? () => {} : handleClickMenu} text={text} action={action}>
                {text}
                {!hiddenDropIcon && (
                  <Icon type="dropdown" color={utilityColor.white} />
                )}
                
              </SubActionButton>
            }

            {ReactDOM.createPortal(
              <div className="contextMenu" css={style.contextMenu}>
                <ContextMenuBox
                  items={buttons}
                  setIsComponentVisible={setIsComponentVisible}
                  isVisible={isComponentVisible}
                  parentEle={parentEle}
                  parentRef={ref}
                  position={position}
                />
              </div>,
              bodyNode,
            )}
          </div>
        </FlexBoxItem>
      </FlexBox>
    );
  };

export default ContextMenu;
